import { render, staticRenderFns } from "./CohortsCrud.vue?vue&type=template&id=686b37a8&scoped=true"
import script from "./CohortsCrud.vue?vue&type=script&lang=js"
export * from "./CohortsCrud.vue?vue&type=script&lang=js"
import style0 from "./CohortsCrud.vue?vue&type=style&index=0&id=686b37a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686b37a8",
  null
  
)

export default component.exports